import cn from 'classnames'
import * as React from 'react'

import useComponentVisible from 'hooks/useComponentVisible'

import { FieldWrapper } from 'components/FieldWrapper'
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper'

import { ReactComponent as ArrowDown } from 'assets/images/svg/arrow_down.svg'

import styles from './InputSelect.module.scss'

interface Props {
  text?: string
  placeholder?: string
  containerClassName?: string
  size?: 'small' | 'medium' | 'extra_small'
  onChangeValue?(value?: string | number): void
  list: {
    title: string
    value: any
  }[]
}

export const InputSelect: React.FC<Props & FieldWrapperProps> = ({
  list,
  onChangeValue,
  text,
  size = 'medium',
  placeholder = 'Выбрать',
  containerClassName,
  ...props
}) => {
  const [value, setValue] = React.useState<any>()
  const [search, setSearch] = React.useState<string>('')
  const { ref, setIsComponentVisible, isComponentVisible } =
    useComponentVisible<HTMLDivElement>(false)

  const filteredList = list.filter(item => {
    if (item.title?.toLowerCase().includes(search?.toLowerCase())) return true
    return false
  })

  const onSelectValue = (value: string | number, title: string) => {
    setIsComponentVisible(false)
    setValue(value)
    setSearch(title)
  }
  const toggleDropdown = React.useCallback(() => {
    setIsComponentVisible(prev => !prev)
  }, [setIsComponentVisible])

  const selectContainerClass = {
    small: styles.selectSmall,
    medium: styles.selectMedium,
    extra_small: styles.selectExtraSmall,
  }

  React.useEffect(() => {
    onChangeValue?.(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <FieldWrapper containerClassName={containerClassName} {...props}>
      <div ref={ref} className={cn(styles.container)}>
        <div
          onClick={toggleDropdown}
          className={cn(
            styles.select,
            isComponentVisible ? styles.select__active : null,
            selectContainerClass[size],
          )}
        >
          <input
            value={search || text}
            onChange={e => setSearch(e.target.value)}
            className={cn(styles.text, text ? styles.text__active : null)}
            placeholder={text || placeholder}
          />
          <div className={styles.icon}>
            <ArrowDown />
          </div>
        </div>
        {isComponentVisible ? (
          <div className={styles.dropdown}>
            {filteredList.map(item => {
              return (
                <div
                  key={item.value}
                  onClick={() => onSelectValue(item.value, item.title)}
                  className={styles.dropdown__item}
                >
                  <div className={styles['dropdown__item--text']}>
                    {item.title}
                  </div>
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    </FieldWrapper>
  )
}
